export default "__VITE_ASSET__4c80e63a__"